<template>
  <div>
    <v-select
      :items="statusOptions"
      v-model="status"
      label="Status"
      dense
      outlined
      clearable
      hide-details
      item-text="title"
      item-value="name"
    />
  </div>
</template>

<script>
import { statusOptions } from '@/assets/data/options'

export default {
  name: 'FilterStatus',
  props: {
    article_status: { type: String },
  },
  data() {
    return {
      statusOptions,
    }
  },
  computed: {
    status: {
      get() {
        if (!this.article_status) return null
        return this.article_status.trim()
      },
      set(value) {
        this.$emit('change', { key: 'article_status', value })
      },
    },
  },
}
</script>

<style lang="less" scoped></style>
